import React, {useState} from 'react';
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";

import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import {patientApi} from "../../redux/services/patientApi";
import {providerApi} from "../../redux/services/providerApi";
import ErrorFlash from "../common/ErrorFlash";
import {getBackgrounds} from "../../helpers/signupRandomBackground";
import './AuthLayout.scss';
import Stack from "@mui/material/Stack";
import config from "../../config/config";

const handleLogout = ({logout, reset, dispatch}) => e => {
  logout();
  reset();
  dispatch(patientApi.util.resetApiState());
  dispatch(providerApi.util.resetApiState());
};

const AuthLayout = props => {
  const {
    children,
    title,
    showLoginBtn = true,
    hasWrapperContent = true
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const getBackgroundIndex  =  () => {
    if (!props.step) {
      return 0;
    }
    return props.step > 0 ? props.step - 1 : props.step
  }

  return (
    <Stack className="AuthLayout" direction='column' overflow='hidden'>
      <ErrorFlash error={props.error} />
      {/*  Header */}
      <Stack className="AuthLayout__header" direction='row' alignItems='center' justifyContent='space-between'>
        {/*<img className="header-image" src="/images/logo-text.png" alt="logoText"/>*/}
        <a href={config().marketingSiteUrl} target='_blank' rel='noreferrer'>
          <div className="header-image"></div>
        </a>
        <Typography variant='pageTitleResponsive' textAlign='center' className="header-title">
          {title}
        </Typography>

        {
          showLoginBtn ? (
            <>
              {props.user && (
                <Button variant='primaryGradient'
                        className="header-login-btn"
                        onClick={() => setLogoutDialogOpen(true)}>
                  <Typography variant='paragraphMedium'>
                    Logout
                  </Typography>
                </Button>
              )}

              {!props.user && (
                <Button variant='primaryGradient'
                        className="header-login-btn"
                        onClick={() => navigate("/login")}>
                  <Typography variant='paragraphMedium'>
                    Login
                  </Typography>
                </Button>
              )}
            </>
          ) : <div></div>
        }

        {
          props.logout && props.user
            ? <Dialog
              open={logoutDialogOpen}
              onClose={() => setLogoutDialogOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle>
                Are you sure?
              </DialogTitle>
              <DialogContent>
                Logging out will discontinue your registration.
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setLogoutDialogOpen(false)}>
                  Cancel
                </Button>
                <Button onClick={handleLogout({...props, dispatch})}>
                  Sign Out
                </Button>
              </DialogActions>
            </Dialog>
            : <></>
        }
      </Stack>
      {/*  Body */}
      <Stack className="AuthLayout__body" direction='row'>
        {/*  Left */}
        <Stack className="AuthLayout__body-left" direction='column' alignItems='center'>
          <Stack
            className={`AuthLayout__body-left-content ${hasWrapperContent && 'AuthLayout__body-left-wrapper'}`}
            direction='column'
            justifyContent='center'
          >
            {children}
          </Stack>
        </Stack>

        {/*  Right */}
        <Stack className="AuthLayout__body-right" direction='row'>
          <img src={getBackgrounds()[getBackgroundIndex()]} alt="patient signup background"/>
        </Stack>
      </Stack>
    </Stack>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  showLoginBtn: PropTypes.bool,
  hasWrapperContent: PropTypes.bool
};

export default AuthLayout;